import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';

import * as helpers from '../helpers';

export const useParseSummaryData = () => {
    const formatter = useFormatter();

    return useCallback(({ balanceFirstBulk = {}, balanceSecondBulk = {} }) => {
        const commonSummary = helpers.mergeSummary(balanceFirstBulk.summary, balanceSecondBulk.summary);
        const {
            currencyCode: startingCurrency, amount: startingAmount
        } = helpers.getStartingBalance(balanceFirstBulk.startingBalances, balanceSecondBulk.startingBalances);
        const {
            currencyCode: endingCurrency, amount: endingAmount
        } = helpers.getCasinoBalance(balanceFirstBulk.endingBalances);

        return {
            summary: Object.keys(commonSummary).reduce((acc, key) => {
                const { amount, currencyCode } = commonSummary[key];

                return {
                    ...acc,
                    [key]: !isNaN(amount) ? formatter.formatCurrency(amount, { currencyCode }) : ''
                };
            }, {}),
            ...startingAmount && {
                startingBalances: formatter.formatCurrency(startingAmount, { currencyCode: startingCurrency })
            },
            ...endingAmount && {
                endingBalances: formatter.formatCurrency(endingAmount, { currencyCode: endingCurrency })
            }
        };
    }, [formatter]);
};
